import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IPeopleCircunstance from '../interfaces/IPeopleCircunstance';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IPeopleCircunstance>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'people-circunstance'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'People circunstance successfully created!'}  
        title={'Add people circunstance'}  
        subheader={'Add people circunstance'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
